import { render, staticRenderFns } from "./Solicitation.vue?vue&type=template&id=3b118390&scoped=true&"
import script from "./Solicitation.vue?vue&type=script&lang=js&"
export * from "./Solicitation.vue?vue&type=script&lang=js&"
import style0 from "./Solicitation.vue?vue&type=style&index=0&id=3b118390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b118390",
  null
  
)

export default component.exports